import apiService from '../api/api.service';
import {
  ApprovalHierarchy,
  ApprovalHierarchyStepPayload,
  ApprovalModule
} from '../../types/approval.types';

/**
 * Departman bazlı onay hiyerarşisi servisi (saha modu / saha aktivitesi).
 * İzin hiyerarşisinden bağımsızdır.
 */
class ApprovalHierarchyService {
  private static instance: ApprovalHierarchyService;

  private constructor() {}

  public static getInstance(): ApprovalHierarchyService {
    if (!ApprovalHierarchyService.instance) {
      ApprovalHierarchyService.instance = new ApprovalHierarchyService();
    }
    return ApprovalHierarchyService.instance;
  }

  public async getHierarchy(module: ApprovalModule, departmentId: number): Promise<ApprovalHierarchy> {
    return apiService.get<ApprovalHierarchy>(`/approval-hierarchies/${module}/departments/${departmentId}`);
  }

  /** Boş steps dizisi hiyerarşiyi kaldırır */
  public async saveHierarchy(
    module: ApprovalModule,
    departmentId: number,
    steps: ApprovalHierarchyStepPayload[]
  ): Promise<ApprovalHierarchy> {
    return apiService.put<ApprovalHierarchy>(`/approval-hierarchies/${module}/departments/${departmentId}`, { steps });
  }

  public async deleteHierarchy(module: ApprovalModule, departmentId: number): Promise<void> {
    await apiService.delete(`/approval-hierarchies/${module}/departments/${departmentId}`);
  }
}

export default ApprovalHierarchyService.getInstance();
